import * as msal from "@azure/msal-browser";
import { updateState } from "../reduxUtil/reduxUtil";
import {
  SET_GROUP_ID,
  LOGOUT,
  SET_POPUP,
  SET_LOADING,
  SET_LOGIN_ERROR,
  SET_TOKEN,
  SET_USER,
  SET_AUTHENTICATED,
  SET_PUBLIC_CLIENT,
  SET_DOCUMENT_DATA,
  SET_SELECTED_DOCUMENTS,
  SET_PARENT_ID,
  SET_IS_ROOT_DIR,
  SET_RESOURCE_DENIED
} from "../actionTypes";
import { Document } from "../../types/types";
import { IObjectWithKey } from "@fluentui/react";

type State = {
  groupId: string;
  isAuthenticated: boolean;
  user: msal.AccountInfo;
  msalClient: msal.PublicClientApplication;
  token: string;
  loading: boolean;
  popupOpen: boolean;
  loginError: string;
  documents: Document[];
  selectedDocuments: IObjectWithKey[];
  parentId: string;
  isRootDir: boolean;
  resourceDenied: boolean;
};

const initialState: State = {
  groupId: "",
  isAuthenticated: false,
  user: null,
  msalClient: null,
  token: "",
  loading: false,
  popupOpen: false,
  loginError: "",
  documents: [],
  selectedDocuments: [],
  parentId: "",
  isRootDir: true,
  resourceDenied: false,
};

const dataReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case LOGOUT:
      return updateState(state, {
        isAuthenticated: false,
        user: null,
        msalClient: null,
        token: null,
        loading: false,
      });

    case SET_SELECTED_DOCUMENTS:
      return updateState(state, {
        selectedDocuments: action.selectedDocuments,
      });

    case SET_PUBLIC_CLIENT:
      return updateState(state, {
        msalClient: action.msalClient,
      });

    case SET_POPUP:
      return updateState(state, {
        popupOpen: action.popupOpen,
      });

    case SET_LOADING:
      return updateState(state, {
        loading: action.loading,
      });

    case SET_LOGIN_ERROR:
      return updateState(state, {
        loginError: action.loginError,
      });

    case SET_TOKEN:
      return updateState(state, {
        token: action.token,
      });

    case SET_AUTHENTICATED:
      return updateState(state, {
        isAuthenticated: action.isAuthenticated,
      });

    case SET_USER:
      return updateState(state, {
        user: action.user,
      });

    case SET_DOCUMENT_DATA:
      return updateState(state, {
        documents: action.documents,
      });

    case SET_PARENT_ID:
      return updateState(state, {
        parentId: action.parentId,
      });

    case SET_IS_ROOT_DIR:
      return updateState(state, {
        isRootDir: action.isRootDir,
      });

    case SET_GROUP_ID:
      return updateState(state, {
        groupId: action.groupId,
      });

    case SET_RESOURCE_DENIED:
      return updateState(state, {
        resourceDenied: action.resourceDenied,
      });

    default:
      return state;
  }
};

export default dataReducer;
